// this file is generated from the root of the admin repo
// see https://github.com/tocktix/admin/wiki/Svg-Icons-Components in order to add a new file;
import * as React from 'react';
import SvgIcon, { SvgIconProps } from '@material-ui/core/SvgIcon';

/**
 * @deprecated use "@tock/icons" import instead
 * This new package will be where all Icons are imported from going forward
 * You can still use these icons in <IconMigrationUtil /> as the legacy icon
 */
export const SvgIconEmptyCart = (props: SvgIconProps) =>
  React.createElement(
    SvgIcon,
    { width: '1em', height: '1em', viewBox: '0 0 24 24', fill: 'none', ...props },
    <path
      d="M23.978 20.568L22.095 6.912c-.152-1.073-1.13-1.878-2.27-1.878h-.946V3.596c0-1.274-.733-2.472-1.914-3.114a4.022 4.022 0 00-3.816 0c-1.181.642-1.914 1.83-1.914 3.114v1.438h-2.29V3.596c0-.719.376-1.399 1.018-1.792.346-.22.448-.67.213-.997a.789.789 0 00-1.058-.2c-1.069.67-1.7 1.791-1.7 2.99v1.437H4.181c-1.15 0-2.117.805-2.27 1.878L.018 20.568a2.09 2.09 0 00.55 1.706c.438.46 1.058.728 1.72.728h19.421c.661 0 1.282-.268 1.72-.737.438-.46.641-1.083.55-1.697zm-21.69.997a.743.743 0 01-.57-.25.69.69 0 01-.183-.565L3.418 7.094c.05-.355.376-.623.753-.623h1.14c.387 0 .702.268.753.623l2.005 14.47H2.288zm20-.25a.786.786 0 01-.57.24H9.618L7.59 6.912a3.15 3.15 0 00-.122-.44h3.766v3.593c0 .393.346.719.763.719.418 0 .764-.326.764-.72V3.597c0-.767.437-1.485 1.15-1.869a2.424 2.424 0 012.29 0c.702.384 1.14 1.102 1.14 1.87v1.437h-3.053c-.418 0-.764.325-.764.718 0 .393.346.72.764.72h3.053v3.593c0 .393.346.719.763.719.418 0 .764-.326.764-.72V6.472h.946c.387 0 .713.268.754.623l1.893 13.656c.03.211-.03.412-.173.566z"
      fill="currentColor"
    />
  );
export default SvgIconEmptyCart;
